import antdEnUS from 'ant-design-vue/es/locale-provider/en_US';
import dayjsLocale from 'dayjs/locale/en';
import momentEnCA from 'moment/dist/locale/en-ca';
import data from '../json/en.json';

// 载入样式
// import(`../style/intl.less`);

const components = {
  antLocale: antdEnUS,
  momentName: 'eu',
  momentLocale: momentEnCA,
  dayjsName: 'en',
  dayjsLocale
};

export default {
  ...components,
  ...data
};
